export const SESSION_QUERY_STALE_TIME_MS = 5 * 60 * 1000

export const sessionQueryOptions = {
  staleTime: SESSION_QUERY_STALE_TIME_MS,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
} as const
